import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
}), 'Bookmark');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Bookmark.js
// module id = 2393
// module chunks = 2